<template>
    <v-dialog v-model="dialog" width="560" persistent :fullscreen="$vuetify.breakpoint.mobile">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card light v-bind="{ loading }" tile class="d-flex flex-column" max-height="90vh" style="overflow: hidden">
            <v-card-title> {{ title }} <v-spacer /> <v-icon @click="dialog = false">mdi-close</v-icon> </v-card-title>
            <v-divider />
            <v-card-text class="py-5" style="flex: 0 1 auto; overflow-y: auto">
                <v-row class="ma-n2">
                    <v-col cols="12" class="pa-2">
                        <form-basic v-model="form" @input="emit" />
                    </v-col>
                    <v-col cols="12" class="pa-2">
                        <form-state v-model="form" @input="emit" />
                    </v-col>
                    <v-col cols="12" class="pa-2">
                        <template v-if="form.code == MANUFACTURING_VENDOR_CODES.DIGIKEY.value">
                            <form-digikey v-model="form" @input="emit" />
                        </template>
                    </v-col>
                    <v-col cols="12" class="pa-2">
                        <template v-if="form.code == MANUFACTURING_VENDOR_CODES.MOUSER.value">
                            <form-mouser v-model="form" @input="emit" />
                        </template>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { initManufacturingVendor } from "@/assets/variables/inits";
import { MANUFACTURING_VENDOR_CODES } from "@/assets/variables/constants";

import FormBasic from "./form/form-basic.vue";
import FormState from "./form/form-state.vue";
import FormDigikey from "./form/form-digikey.vue";
import FormMouser from "./form/form-mouser.vue";

export default {
    components: {
        FormBasic,
        FormState,
        FormDigikey,
        FormMouser,
    },
    props: {
        value: { type: Object, default: initManufacturingVendor },
    },
    data: () => ({
        form: initManufacturingVendor(),

        dialog: false,
        loading: false,

        MANUFACTURING_VENDOR_CODES,
    }),
    computed: {
        isCreate() {
            return !this.value._id;
        },
        title() {
            let title = "벤더정보";
            title += this.isCreate ? " 생성" : " 수정";
            return title;
        },
    },
    watch: {
        dialog() {
            if (this.dialog) this.init();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                if (this.isCreate) {
                    this.form = initManufacturingVendor(this.value);
                } else {
                    let { _id } = this.value;
                    this.form = initManufacturingVendor((await api.console.manufacturing.vendors.get({ _id }))?.vendor);
                    this.$emit("input", this.form);
                }
            } finally {
                this.loading = false;
            }
        },
        emit() {
            this.form = initManufacturingVendor(this.form);
        },
        validates() {
            let { name } = this.form;
            if (!name) throw new Error("이름을 입력하셔야 합니다");
        },
        async save() {
            if (this.loading) return;

            this.loading = true;
            try {
                this.validates();

                let { post, put } = api.console.manufacturing.vendors;
                let { ...form } = this.form;
                let vendor = (await (this.isCreate ? post : put)(form))?.vendor;

                alert(this.isCreate ? "생성되었습니다" : "수정되었습니다");
                this.$emit("input", vendor);
                this.dialog = false;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .text-align-right-field {
    & > .v-input__control > .v-input__slot > .v-text-field__slot > input {
        text-align: right !important;
    }
}
::v-deep .amount-field {
    & > .v-input__control > .v-input__slot {
        padding-right: 0 !important;
    }
    & > .v-input__control > .v-input__slot > .v-input__append-inner {
        margin: 1px 0 0;
    }
    & > .v-input__control > .v-input__slot > .v-input__append-inner > .v-text-field--solo {
        width: 58px !important;

        .v-input__slot {
            padding-right: 4px;
        }
        .v-select__selections {
            justify-content: center;

            > .v-select__selection {
                margin-right: 0;
            }

            > input {
                display: none;
            }
        }

        .v-input__control,
        .v-input__slot {
            background-color: transparent;
        }
        .v-input__append-inner {
            margin-top: 0;
            padding-left: 0;
        }
    }
}

::v-deep .v-text-field__details {
    margin-bottom: 0 !important;
}

::v-deep .w-100-px {
    width: 100px;
}
</style>
